import { useCallback, useMemo, useState } from "react";
import { IUseItemsPaginator, IUseItemsPaginatorParams } from "./useItemsPaginator.types";

export const useItemsPaginator = <T, >({ perPage, items }: IUseItemsPaginatorParams<T>): IUseItemsPaginator<T> => {
  const [page, setPage] = useState<number>(1)
  const itemsToRender = useMemo(() => {
    if (items?.length) {
      const start = perPage * (page - 1)
      const end = perPage * page
      return items.slice(start, end)
    }
    return []
  }, [page, items, perPage])

  const total = !!items?.length ? items?.length : 0

  const totalPages = !!items?.length ? Math.ceil(items?.length / perPage) : 1

  const handleChangePage = useCallback((newPage: number) => {
    if (newPage < 1) {
      setPage(1)
    } else if (newPage > totalPages) {
      setPage(totalPages)
    } else {
      setPage(newPage)
    }
  }, [totalPages])

  return {
    itemsToRender,
    currentPage: page,
    total,
    totalPages,
    perPage,
    handleChangePage,
  }
}
